import { Box, styled } from '@mui/material';

export const BasePanelBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.fade,
    flex: 1,
  }));
  